// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IReceiptDetailsSaveRequest,
  TReceiptDetailsSaveModel,
  IMappers,
  TReceiptDetailsSaveResponse,
  IReceiptDetailsSaveResponse,
  IReceiptDetailsSaveResponseError,
} from './types';

export const defaultConfig: TReceiptDetailsSaveModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'dailyrent',
  pathApi: '/v1/receipt-details/save/',
  requestType: 'json',
} as TReceiptDetailsSaveModel;

export function createReceiptDetailsSaveModel(parameters: IReceiptDetailsSaveRequest): TReceiptDetailsSaveModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IReceiptDetailsSaveOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IReceiptDetailsSaveRequest;
}

export async function fetchReceiptDetailsSave<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IReceiptDetailsSaveOptions<TResponse200, TResponse400>): Promise<
  TReceiptDetailsSaveResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createReceiptDetailsSaveModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IReceiptDetailsSaveResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IReceiptDetailsSaveResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TReceiptDetailsSaveResponse;
}
